import { render, staticRenderFns } from "./Ibpt.vue?vue&type=template&id=27c2ba31&scoped=true"
import script from "./Ibpt.vue?vue&type=script&lang=js"
export * from "./Ibpt.vue?vue&type=script&lang=js"
import style0 from "./Ibpt.vue?vue&type=style&index=0&id=27c2ba31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2ba31",
  null
  
)

export default component.exports